export const LIFETIME_COUPON = 'lifetime';
export const BEEZER_ONE_YEAR_COUPON = 'beezeroneyear';
export const JAN_50_OFF = 'january_50_off';
export const BEEZER_19_ONE_YEAR = 'beezeroneyear19';
